import _ from 'lodash'
import {getMaxId} from '@/utils/paperUtil'

function updateList(data) {
    // let fromDataJSON = localStorage.getItem('questionData');
    // if (fromDataJSON){
    //     let fromData_ = JSON.parse(fromDataJSON);
    //     fromData_.groupList = data
    //     localStorage.setItem('questionData', JSON.stringify(fromData_));
    // }
}

export default {
    namespaced: true,
    state: {
        groupList: [],
        id: 1,
    },
    getters: {
        currentGroup: (state, getters, rootState, rootGetters) => (id) => {
            let group = state.groupList.find((item) => item.id === id)
            if (group) {
                group = _.cloneDeep(group)
                let paperList = []
                group.paperIds.forEach((id) => {
                    paperList.push(rootGetters['question/paper/paperById'](id))
                })
                group.paperList = [...paperList, ...getters.surplusPaperList]
            }else {
                return []
            }
            return group
        },
        currentGroupList(state, getters, rootState, rootGetters) {
            let groupList = _.cloneDeep(state.groupList);
            groupList.forEach((group) => {
                let paperList = []
                group.paperIds.forEach((id) => {
                    paperList.push(rootGetters['question/paper/paperById'](id))
                })
                if (paperList.length) {
                    paperList = _.sortBy(paperList,
                        [o => o.paperNum.split('-')[0],o => Number(o.paperNum.split('-')[1])])
                }
                group.paperList = paperList
            })
            return groupList
        },
        surplusPaperList(state, getters, rootState, rootGetters) {
            let groupPaperIds = state.groupList.map((item) => item.paperIds)
            groupPaperIds = _.flattenDepth(groupPaperIds, 2)
            groupPaperIds = _.uniq(groupPaperIds);
            const paperList = rootState.question.paper.paperList
            let surplusPaperList =  _.differenceWith(paperList, groupPaperIds, (arrVal, othVal) => {
                return arrVal.id === othVal
            })
            if (surplusPaperList && surplusPaperList.length) {
                surplusPaperList = _.sortBy(surplusPaperList,
                    [o => o.paperNum.split('-')[0],o => Number(o.paperNum.split('-')[1])])
            }
            return _.cloneDeep(surplusPaperList)
        },
    },
    mutations: {
        init(state, { data, id }) {
            state.groupList = data
            state.id = id
        },
        add(state, data) {
            if (data) {
                data.id = state.id
                state.groupList.push(data)
                state.id++
                updateList(state.groupList)
            }
        },
        update(state, data) {
            if (data) {
                const index = state.groupList.findIndex(item => item.id === data.id)
                if (index >= 0) {
                    state.groupList.splice(index, 1, data)
                    updateList(state.groupList)
                }
            }
        },
        remove(state, id) {
            const index = state.groupList.findIndex(item => item.id === id)
            if (index >= 0) {
                state.groupList.splice(index, 1)
                updateList(state.groupList)
            }
        },
        updateClassifyName(state, {id , classifyName}) {
            const index = state.groupList.findIndex(item => item.id === id)
            if (index >= 0) {
                state.groupList[index].classifyName = classifyName
                updateList(state.groupList)
            }
        },
        updatePaperIds(state, {id , paperIds}) {
            const index = state.groupList.findIndex(item => item.id === id)
            if (index >= 0) {
                state.groupList[index].paperIds = paperIds
                updateList(state.groupList)
            }
        },
        removePaperId(state, paperId) {
            state.groupList.forEach((item,index) => {
                item.paperIds = _.difference(item.paperIds, [paperId])
            })
            updateList(state.groupList)
        }
    },
    actions: {
        init({ state, rootState, commit,  dispatch,   getters, rootGetters }, groupList) {
            // 初始化
            if (groupList && groupList.length) {
                let maxId = getMaxId(groupList)
                const id = ++maxId
                commit('init', {
                    data: groupList,
                    id: id
                })
            }
        },
        add({ state, rootState, commit,  dispatch,   getters, rootGetters }) {

        }
    }
}
